import { appConfig } from 'config/customization';
import { defaultPaddingLeft, mobileDefaultPaddingLeft } from 'constants/sizes';
import Device from 'constants/deviceSizes';

export const borderStyle = `1px solid ${appConfig.colors.bordersGray}`;

export default {
  container: {
    overflow: 'hidden',
    borderTop: borderStyle,
    padding: `5px ${defaultPaddingLeft}px`,
    [Device.mobile]: {
      padding: `5px ${mobileDefaultPaddingLeft}px`
    }
  }
};
